import React, {useEffect, useState} from 'react'
import {Alert, Spin} from 'antd'
import {apiGetRequest} from '../http/http'
import ScoreResult360 from './OA/Score/ScoreResult360'
import GuanyuanPage from './GuanyuanPage/GuanyuanPage'

const REPORT_ID = '1804082748401258496'

// 校验完成前不挂载业务页面；每次进入页面均由后端检查当前登录用户。
export function ReportAccessGate({checkAccess, children}) {
    const [access, setAccess] = useState('checking')
    useEffect(() => {
        let active = true
        Promise.resolve().then(checkAccess).then(allowed => {
            if (active) setAccess(allowed === true ? 'allowed' : 'denied')
        }).catch(() => {
            if (active) setAccess('denied')
        })
        return () => { active = false }
    }, [checkAccess])
    if (access === 'checking') return <Spin tip="正在校验访问权限" />
    if (access !== 'allowed') return <Alert type="error" showIcon message="无法访问此报表" description="权限校验未通过，请联系管理员确认授权后重试。" />
    return children
}

const check360Access = () => apiGetRequest('/lechun-baseservice/eval/checkResultAccess')
const checkGuanyuanAccess = () => apiGetRequest('/lechun-baseservice/sso/checkGuanyuanReportAccess')

export function ProtectedScoreResult360(props) {
    return <ReportAccessGate checkAccess={check360Access}><ScoreResult360 {...props} /></ReportAccessGate>
}

export function ProtectedGuanyuanReport(props) {
    const search = props.location ? props.location.search : window.location.search
    const ids = new URLSearchParams(search).getAll('id')
    // 路由恢复后仅允许指定报表，其余此前下线的观远页面继续保持关闭。
    if (ids.length !== 1 || ids[0] !== REPORT_ID) {
        return <Alert type="error" showIcon message="页面暂未开放" />
    }
    return <ReportAccessGate checkAccess={checkGuanyuanAccess}><GuanyuanPage {...props} /></ReportAccessGate>
}
